const HorizontalAccountCardStrings = {
  accountCard: { buttons: { activateLabel: 'Activate' } },
};

export default HorizontalAccountCardStrings;
